import "./Header.css";

export default function Header(props) {
  const Create = () => {
    props.updateType(0);
  };

  const Summary = () => {
    props.updateType(1);
  };
  const User = () => {
    props.updateType(2);
  };

  return (
    <div className="UserHeader py-4">
      <div className="UserLeft">
        <button
          onClick={Summary}
          className={
            props.type == 1
              ? "NavLinkBtn large selectlink marginright"
              : "NavLinkBtn large unselectlink marginright"
          }
        >
          SUMMARY SUPER
        </button>
        <button
          onClick={User}
          className={
            props.type == 2
              ? "NavLinkBtn large selectlink marginright"
              : "NavLinkBtn large unselectlink marginright"
          }
        >
          SUPER
        </button>
      </div>
      <div className="UserRight">
        <button onClick={Create} className={"NavLinkBtn large unselectlink"}>
          CREATE SUPER
        </button>
      </div>
    </div>
  );
}
